import { FC } from 'react';

import { Divider, Stack } from '@mui/material';

import { TGenerations } from 'shared/services/types/generations.types';

interface IProps {
  methodGeneration?: TGenerations.checkIsGenerationResponse;
}

export const GenerationInfo: FC<IProps> = ({ methodGeneration }) => {
  return (
    <>
      <Stack justifyContent={'space-between'} direction={'row'}>
        Number of applications per account
        <span>{methodGeneration?.applications_per_account}</span>
      </Stack>
      <Divider></Divider>
      <Stack justifyContent={'space-between'} direction={'row'}>
        Number of transactions per application
        <span>{methodGeneration?.transactions_per_account}</span>
      </Stack>
      <Divider></Divider>
      <Stack justifyContent={'space-between'} direction={'row'}>
        Percentage of applications that are not suitable by amount
        <span>{methodGeneration?.percentage_of_applications}</span>
      </Stack>
      <Divider></Divider>
      <Stack justifyContent={'space-between'} direction={'row'}>
        Percentage of transactions not suitable for matching
        <span>{methodGeneration?.percentage_of_transactions}</span>
      </Stack>
      <Divider></Divider>
      <Stack justifyContent={'space-between'} direction={'row'}>
        Method<span>{methodGeneration?.method_id}</span>
      </Stack>
    </>
  );
};
